export default __webpack_public_path__ + "static/media/valleyPort4.52ceedb6.png";